import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const futuresChangeHistorySchema = z.object({
  /** Change time */
  time: z.number(),
  /** Change amount */
  change: decimalSchema,
  /** Balance after change */
  balance: decimalSchema,
  /** Changing Type */
  type: z.union([
    z.literal('dnw'),
    z.literal('pnl'),
    z.literal('fee'),
    z.literal('refr'),
    z.literal('fund'),
    z.literal('point_dnw'),
    z.literal('point_fee'),
    z.literal('point_refr'),
    z.literal('bonus_dnw'),
    z.literal('bonus_offset'),
  ]),
  /** Comment */
  text: z.string(),
  /** Futures contract (available only for data after 2023-10-30) */
  contract: z.string().optional(),
  /** Trade ID */
  trade_id: z.string().optional(),
  /** Account change record ID */
  id: z.string().optional(),
})

export const responseSchema = z.array(futuresChangeHistorySchema)
